import { WalletIcon } from "@heroicons/react/24/outline";

const CardManagement = [
    {
        path: "card-management",
        fullPath: "content-management/card-management",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Card Management",
        displayPath: "Content Management > Page Management > Card Management",
        icon: WalletIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/ContentManagement/PageManagement/CardManagement"
                    );
                    return {
                        Component: component.default,
                    };
                },
                //permissions: [""],
            },
            {
                path: "create",
                async lazy() {
                    const component = await import(
                        "../../pages/ContentManagement/PageManagement/cards/Upsert"
                    );
                    return {
                        Component: component.default,
                    };
                },
                exact: true,
                //permissions: [""],
            },
            {
                path: ":slug/edit/:id",
                async lazy() {
                    const component = await import(
                        "../../pages/ContentManagement/PageManagement/cards/Upsert"
                    );
                    return {
                        Component: component.default,
                    };
                },
                exact: true,
                //permissions: [""],
            },
        ],
    }
]
export default CardManagement;